import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChineseNewYear = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16.255 6.708A12.7 12.7 0 0 0 11.238 4L9.573 9.29c.964.319 1.84.805 2.596 1.428zM6.89 3.514c.99-.043 1.953.015 2.877.164L8.108 8.95a9 9 0 0 0-1.61-.076h-.006c-.297.015-.582.045-.859.081a.75.75 0 0 0-.648.651L3.646 4.015a15.2 15.2 0 0 1 3.244-.501m-.325 6.859q.556-.024 1.085.032L6.245 14.87l-1.137-4.75a.75.75 0 0 0 .718.324c.252-.033.494-.058.74-.07m-.583 8.038a.75.75 0 0 1-.57-.58L2.023 3.673a.747.747 0 0 1 .503-.895 16.8 16.8 0 0 1 4.3-.763c4.363-.187 8.24 1.39 10.985 4.092a.8.8 0 0 1 .115.115c2.698 2.72 4.264 6.546 4.057 10.847a16.4 16.4 0 0 1-.839 4.42.75.75 0 0 1-.893.489zm3.029-.789 10.916 2.729c.31-1.085.502-2.21.557-3.354a13.7 13.7 0 0 0-.132-2.698l-5.366 1.572q.091.727.055 1.494v.005q-.02.401-.075.824a.75.75 0 1 1-1.486-.203q.044-.34.063-.701.025-.506-.02-.99zm5.651-3.219 5.382-1.577a12.5 12.5 0 0 0-2.726-5.06l-4.088 4.012a7.9 7.9 0 0 1 1.432 2.625m-1.44.422-4.413 1.293 3.346-3.284a6.4 6.4 0 0 1 1.066 1.991m-4.099-4.104-1.36 4.322 3.328-3.267a6.5 6.5 0 0 0-1.968-1.055"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChineseNewYear;
